var Vendd = (function (Vendd) {
    'use strict';

    Vendd.MessageBus.subscribe(Vendd.CallMeBack.Messages.Submit, Vendd.CallMeBack, function (envelope) {
        var options = {
            url: 'CallMeBackService.svc/SubmitCallMeBackRequest',
            data: { info: envelope.message.data },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            if (response.success) {
                Vendd.MessageBus.publishAsync(Vendd.CallMeBack, new Vendd.CallMeBack.Messages.SubmitSuccess(response));
            } else {
                Vendd.MessageBus.publishAsync(Vendd.CallMeBack, new Vendd.CallMeBack.Messages.SubmitFailure(response));
            }
        };

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.CallMeBack, new Vendd.CallMeBack.Messages.SubmitFailure(response));
        };

        Vendd.Service.call(options);
    });

    return Vendd;

})(Vendd || {});